import { TUpdateDataSourceParams } from '@commenda/types/src/datasource/types';
import { fetcher } from '@commenda/utils';

const updateDatasource = async (id: string, body: TUpdateDataSourceParams) => {
  const response = await fetcher(`datasource/${id}`, {
    method: 'POST',
    body,
  });

  return response;
};

export { updateDatasource };
